module.exports = __webpack_public_path__ + "img/Financial_Advisor_880x660_DemoScreen_Avada-600x450.f3c8aff0.jpg";